<template>
  <div class="second-bar">
    <div class="container">
      <h2 class="title primary-title">
        {{ $t("instructionPage.secondTitle") }}
      </h2>
      <div class="description primary-text">
        {{ $t("instructionPage.help") }}
      </div>
      <ul class="list">
        <li class="item">
          <svg
            width="4.9375rem"
            height="4.9375rem"
            viewBox="0 0 79 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="79" height="79" rx="10" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M38.9998 58.3337C28.8746 58.3337 20.6665 50.1255 20.6665 40.0003C20.6665 29.8751 28.8746 21.667 38.9998 21.667C49.1251 21.667 57.3332 29.8751 57.3332 40.0003C57.3332 50.1255 49.1251 58.3337 38.9998 58.3337ZM51.3323 48.5414C53.0142 46.1175 53.9998 43.174 53.9998 40.0003C53.9998 31.7161 47.2841 25.0003 38.9998 25.0003C30.7156 25.0003 23.9998 31.7161 23.9998 40.0003C23.9998 43.174 24.9855 46.1175 26.6673 48.5414C28.5431 46.0638 32.9508 45.0003 38.9998 45.0003C45.0488 45.0003 49.4566 46.0638 51.3323 48.5414ZM48.941 51.2333C48.4532 49.4792 44.9488 48.3337 38.9998 48.3337C33.0509 48.3337 29.5465 49.4792 29.0587 51.2333C31.7053 53.5773 35.1864 55.0003 38.9998 55.0003C42.8133 55.0003 46.2943 53.5773 48.941 51.2333ZM38.9998 30.0003C34.965 30.0003 32.3332 32.9266 32.3332 36.667C32.3332 42.3793 35.2679 45.0003 38.9998 45.0003C42.6966 45.0003 45.6665 42.4663 45.6665 37.0003C45.6665 33.203 43.0235 30.0003 38.9998 30.0003ZM35.6665 36.667C35.6665 40.4491 37.0302 41.667 38.9998 41.667C40.9627 41.667 42.3332 40.4976 42.3332 37.0003C42.3332 34.9177 41.0259 33.3337 38.9998 33.3337C36.8894 33.3337 35.6665 34.6934 35.6665 36.667Z"
              fill="#377DFF"
            />
          </svg>
          <p class="item-text primary-text">{{ data[0] }}</p>
        </li>
        <li class="item">
          <svg
            width="4.9375rem"
            height="4.9375rem"
            viewBox="0 0 79 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="79" height="79" rx="10" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M32.3335 29.9997H29.0002V28.333H25.6668V33.333H52.3335V28.333H49.0002V29.9997H45.6668V28.333H32.3335V29.9997ZM52.3335 36.6663H25.6668V53.333H52.3335V36.6663ZM45.6668 24.9997H32.3335V23.333H29.0002V24.9997H25.6668C23.8259 24.9997 22.3335 26.4921 22.3335 28.333V53.333C22.3335 55.174 23.8259 56.6663 25.6668 56.6663H52.3335C54.1744 56.6663 55.6668 55.174 55.6668 53.333V28.333C55.6668 26.4921 54.1744 24.9997 52.3335 24.9997H49.0002V23.333H45.6668V24.9997ZM30.6668 43.333V39.9997H34.0002V43.333H30.6668ZM37.3335 43.333H40.6668V39.9997H37.3335V43.333ZM44.0002 43.333V39.9997H47.3335V43.333H44.0002ZM30.6668 46.6663V49.9997H34.0002V46.6663H30.6668ZM40.6668 49.9997H37.3335V46.6663H40.6668V49.9997Z"
              fill="#377DFF"
            />
          </svg>

          <p class="item-text primary-text">{{ data[1] }}</p>
        </li>
        <li class="item">
          <svg
            width="4.9375rem"
            height="4.9375rem"
            viewBox="0 0 79 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="79" height="79" rx="10" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.6668 31.6663H29.0002V23.333H49.0002V31.6663H52.3335C54.1744 31.6663 55.6668 33.1587 55.6668 34.9997V48.333C55.6668 50.174 54.1744 51.6663 52.3335 51.6663H49.0002V56.6663H29.0002V51.6663H25.6668C23.8259 51.6663 22.3335 50.174 22.3335 48.333V34.9997C22.3335 33.1587 23.8259 31.6663 25.6668 31.6663ZM45.6668 31.6663H32.3335V26.6663H45.6668V31.6663ZM52.3335 48.333H49.0002V44.9997H29.0002V48.333H25.6668V34.9997H52.3335V48.333ZM45.6668 48.333H32.3335V53.333H45.6668V48.333ZM50.6668 38.333C50.6668 37.4125 49.9206 36.6663 49.0002 36.6663C48.0797 36.6663 47.3335 37.4125 47.3335 38.333C47.3335 39.2535 48.0797 39.9997 49.0002 39.9997C49.9206 39.9997 50.6668 39.2535 50.6668 38.333Z"
              fill="#377DFF"
            />
          </svg>
          <p class="item-text primary-text">{{ data[2] }}</p>
        </li>
        <li class="item">
          <svg
            width="4.9375rem"
            height="4.9375rem"
            viewBox="0 0 79 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="79" height="79" rx="10" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M47.3335 21.667H30.6668C28.8259 21.667 27.3335 23.1594 27.3335 25.0003V55.0003C27.3335 56.8413 28.8259 58.3337 30.6668 58.3337H47.3335C49.1744 58.3337 50.6668 56.8413 50.6668 55.0003V25.0003C50.6668 23.1594 49.1744 21.667 47.3335 21.667ZM30.6668 25.0003H35.6668C35.6668 25.9208 36.413 26.667 37.3335 26.667H40.6668C41.5873 26.667 42.3335 25.9208 42.3335 25.0003H47.3335V55.0003H30.6668V25.0003Z"
              fill="#377DFF"
            />
          </svg>
          <p class="item-text primary-text">{{ data[3] }}</p>
        </li>
        <li class="item">
          <svg
            width="4.9375rem"
            height="4.9375rem"
            viewBox="0 0 79 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="79" height="79" rx="10" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M39 58.8796L40.0962 57.9224C49.3145 49.8732 54 42.8449 54 36.667C54 27.9181 47.1716 21.667 39 21.667C30.8284 21.667 24 27.9181 24 36.667C24 42.8449 28.6855 49.8732 37.9038 57.9224L39 58.8796ZM39 54.4393C31.1777 47.3896 27.3333 41.4157 27.3333 36.667C27.3333 29.828 32.6069 25.0003 39 25.0003C45.3931 25.0003 50.6667 29.828 50.6667 36.667C50.6667 41.4157 46.8223 47.3896 39 54.4393ZM39 28.3337C43.6024 28.3337 47.3333 32.0646 47.3333 36.667C47.3333 41.2694 43.6024 45.0003 39 45.0003C34.3976 45.0003 30.6667 41.2694 30.6667 36.667C30.6667 32.0646 34.3976 28.3337 39 28.3337ZM34 36.667C34 33.9056 36.2386 31.667 39 31.667C41.7614 31.667 44 33.9056 44 36.667C44 39.4284 41.7614 41.667 39 41.667C36.2386 41.667 34 39.4284 34 36.667Z"
              fill="#377DFF"
            />
          </svg>
          <p class="item-text primary-text">{{ data[4] }}</p>
        </li>
        <li class="item">
          <svg
            width="4.9375rem"
            height="4.9375rem"
            viewBox="0 0 79 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="79" height="79" rx="10" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M57.3332 40.0003C57.3332 29.8751 49.1251 21.667 38.9998 21.667C28.8746 21.667 20.6665 29.8751 20.6665 40.0003C20.6665 50.1255 28.8746 58.3337 38.9998 58.3337C49.1251 58.3337 57.3332 50.1255 57.3332 40.0003ZM52.9293 34.4245C51.407 30.625 48.3752 27.5932 44.5756 26.0709C45.4671 27.7918 46.1664 29.9374 46.6377 32.3624C49.0628 32.8338 51.2084 33.5331 52.9293 34.4245ZM31.3619 32.3624C31.8333 29.9374 32.5326 27.7918 33.424 26.0709C29.6245 27.5932 26.5927 30.625 25.0704 34.4245C26.7913 33.5331 28.9369 32.8338 31.3619 32.3624ZM23.9998 40.0003C23.9998 38.5016 26.7143 36.8753 30.8573 35.8973C30.7316 37.2183 30.6665 38.592 30.6665 40.0003C30.6665 41.4086 30.7316 42.7823 30.8573 44.1033C26.7143 43.1253 23.9998 41.4991 23.9998 40.0003ZM25.0704 45.5761C26.7913 46.4676 28.9369 47.1669 31.3619 47.6382C31.8333 50.0633 32.5326 52.2089 33.424 53.9298C29.6245 52.4075 26.5927 49.3757 25.0704 45.5761ZM46.6377 47.6382C46.1664 50.0633 45.4671 52.2089 44.5756 53.9298C48.3752 52.4075 51.407 49.3757 52.9293 45.5761C51.2084 46.4676 49.0628 47.1669 46.6377 47.6382ZM47.3332 40.0003C47.3332 41.4086 47.2681 42.7823 47.1424 44.1033C51.2854 43.1253 53.9998 41.4991 53.9998 40.0003C53.9998 38.5016 51.2854 36.8753 47.1424 35.8973C47.2681 37.2183 47.3332 38.592 47.3332 40.0003ZM33.9998 40.0003C33.9998 38.3499 34.1033 36.7665 34.2875 35.288C35.766 35.1038 37.3494 35.0003 38.9998 35.0003C40.6503 35.0003 42.2337 35.1038 43.7121 35.288C43.8963 36.7665 43.9998 38.3499 43.9998 40.0003C43.9998 41.6508 43.8963 43.2341 43.7121 44.7126C42.2337 44.8968 40.6503 45.0003 38.9998 45.0003C37.3494 45.0003 35.766 44.8968 34.2875 44.7126C34.1033 43.2341 33.9998 41.6508 33.9998 40.0003ZM34.8968 48.1429C35.8748 52.2859 37.5011 55.0003 38.9998 55.0003C40.4986 55.0003 42.1248 52.2859 43.1029 48.1429C41.7818 48.2686 40.4082 48.3337 38.9998 48.3337C37.5915 48.3337 36.2179 48.2686 34.8968 48.1429ZM38.9998 25.0003C37.5011 25.0003 35.8748 27.7148 34.8968 31.8578C36.2179 31.7321 37.5915 31.667 38.9998 31.667C40.4082 31.667 41.7818 31.7321 43.1029 31.8578C42.1248 27.7148 40.4986 25.0003 38.9998 25.0003Z"
              fill="#377DFF"
            />
          </svg>
          <p class="item-text primary-text">{{ data[5] }}</p>
        </li>
        <li class="item">
          <svg
            width="4.9375rem"
            height="4.9375rem"
            viewBox="0 0 79 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="79" height="79" rx="10" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.3335 52.8676L34.1801 56.8164L45.795 50.1793L55.6668 54.128V27.2046L45.5386 23.1533L33.8203 29.8495L22.3335 26.0206V52.8676ZM42.3335 48.3182L35.6668 52.1277V32.6335L42.3335 28.824V48.3182ZM45.6668 46.5379L52.3335 49.2046V29.4614L45.795 26.846L45.6668 26.9192V46.5379ZM25.6668 50.465L32.3335 52.6873V32.8676L25.6668 30.6454V50.465Z"
              fill="#377DFF"
            />
          </svg>
          <p class="item-text primary-text">{{ data[6] }}</p>
        </li>
        <li class="item">
          <svg
            width="4.9375rem"
            height="4.9375rem"
            viewBox="0 0 79 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="79" height="79" rx="10" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M53.9998 28.3333C55.8408 28.3333 57.3332 29.8257 57.3332 31.6667V51.6667C57.3332 53.5076 55.8408 55 53.9998 55H23.9998C22.1589 55 20.6665 53.5076 20.6665 51.6667V28.3333C20.6665 26.4924 22.1589 25 23.9998 25H33.9998C35.8665 25 37.0547 25.7924 38.2481 27.2981C38.2811 27.3397 38.3616 27.4434 38.4507 27.5583L38.4509 27.5585C38.5766 27.7205 38.7196 27.9047 38.7706 27.968C38.8223 28.0321 38.8659 28.0851 38.9019 28.1289C39.0485 28.3071 39.0697 28.333 39.0028 28.3333H53.9998ZM53.9998 51.6667V31.6667L38.9909 31.6666C37.794 31.6602 37.0143 31.0998 36.1762 30.0609C36.1003 29.9668 35.916 29.7292 35.782 29.5565L35.7818 29.5562L35.7818 29.5562C35.7117 29.4658 35.6555 29.3934 35.6358 29.3686C35.0115 28.5809 34.6402 28.3333 33.9998 28.3333H23.9998V51.6667H53.9998ZM43.9998 41.6667C43.9998 44.4281 41.7613 46.6667 38.9998 46.6667C36.2384 46.6667 33.9998 44.4281 33.9998 41.6667C33.9998 38.9052 36.2384 36.6667 38.9998 36.6667C41.7613 36.6667 43.9998 38.9052 43.9998 41.6667ZM30.6665 41.6667C30.6665 46.269 34.3975 50 38.9998 50C43.6022 50 47.3332 46.269 47.3332 41.6667C47.3332 37.0643 43.6022 33.3333 38.9998 33.3333C34.3975 33.3333 30.6665 37.0643 30.6665 41.6667ZM48.9998 35C48.9998 35.9205 49.746 36.6667 50.6665 36.6667C51.587 36.6667 52.3332 35.9205 52.3332 35C52.3332 34.0795 51.587 33.3333 50.6665 33.3333C49.746 33.3333 48.9998 34.0795 48.9998 35Z"
              fill="#377DFF"
            />
          </svg>
          <p class="item-text primary-text">{{ data[7] }}</p>
        </li>
        <li class="item">
          <svg
            width="4.9375rem"
            height="4.9375rem"
            viewBox="0 0 79 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="79" height="79" rx="10" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M54 56.6663H29C26.2386 56.6663 24 54.4278 24 51.6663V28.333C24 25.5716 26.2386 23.333 29 23.333H54V49.9997C53.0795 49.9997 52.3333 50.7459 52.3333 51.6663C52.3333 52.5868 53.0795 53.333 54 53.333V56.6663ZM49 51.6663C49 51.0819 49.1003 50.521 49.2845 49.9997H29C28.0795 49.9997 27.3333 50.7459 27.3333 51.6663C27.3333 52.5868 28.0795 53.333 29 53.333H49.2845C49.1003 52.8117 49 52.2507 49 51.6663ZM29 26.6663H50.6667V46.6663H29C28.4156 46.6663 27.8546 46.7666 27.3333 46.9508V28.333C27.3333 27.4125 28.0795 26.6663 29 26.6663Z"
              fill="#377DFF"
            />
          </svg>
          <p class="item-text primary-text">{{ data[8] }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { useLanguage } from "@/utils/language";
const { i18n } = useLanguage();
const locale = i18n.global.locale.value;
const data = i18n.global.messages.value[locale].instructionPage.arrayDoc;
</script>

<style lang="scss" scoped>
.mobile-help {
  display: none;
}
.svg {
  position: absolute;
  top: 0;
  left: 0;
}
.second-bar {
  width: 100%;
  background: var(--bg-light-grey);
  
  .title {
    margin-bottom: 1.4375rem;
  }

  .description {
    color: var(--primary-blue);
  }
}
.list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 4.625rem;
  grid-gap: 0.625rem;
  grid-row-gap: 3.75rem;

  .item {
    &-text {
      font-weight: 700;
      margin-top: 2.1875rem;
    }
  }
}

@media screen and (max-width: 768px) {
  .list {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 0.9375rem;
    grid-row-gap: 2.125rem;
  }
}
@media screen and (max-width: 576px) {
}
</style>
